export default __webpack_public_path__ + "static/media/sc29.29356404.mp4";